import React from 'react'

function Charge(props) {
  const fillColor = props.hovered === 'charge' || props.selected === 'Charge Event' ? '#F37320' : '#545455'
  const strokeColor = props.hovered === 'charge' || props.selected === 'Charge Event' ? '#F37320' : '#707070'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="163.576" height="103.267" viewBox="0 0 163.576 103.267">
      <g id="Group_7418" data-name="Group 7418" transform="translate(18288 -10401.746)">
        <g id="Rectangle_5575" data-name="Rectangle 5575" transform="translate(-18288 10407.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5576" data-name="Rectangle 5576" transform="translate(-18284.539 10486.838)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="14.713" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="13.713" rx="3.5" fill="none" />
        </g>
        <path id="Path_3644" data-name="Path 3644" d="M3614.863,5076.646h19.228" transform="translate(-21888.373 5325.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
        <g id="Rectangle_5577" data-name="Rectangle 5577" transform="translate(-18230.012 10407.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5578" data-name="Rectangle 5578" transform="translate(-18226.551 10457.412)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="44.139" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="43.139" rx="3.5" fill="none" />
        </g>
        <path id="Path_3645" data-name="Path 3645" d="M3614.863,5076.646h19.228" transform="translate(-21830.477 5325.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
        <g id="Rectangle_5579" data-name="Rectangle 5579" transform="translate(-18172.025 10407.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5580" data-name="Rectangle 5580" transform="translate(-18168.564 10421.063)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="80.489" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="79.489" rx="3.5" fill="none" />
        </g>
        <path id="Path_3646" data-name="Path 3646" d="M3614.863,5076.646h19.228" transform="translate(-21772.58 5325.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
      </g>
    </svg>

  )
}

export default Charge